import { makeAutoObservable } from 'mobx'

import { HelpApi } from '../api'
import type { Config, HelpCopy, HelpAlertProps, Ticket } from '../types'
import { HelpUtil } from '../utils/HelpUtil'

import { GlobalStore } from './GlobalStore'

export class HelpStore {
  alert: HelpAlertProps = { message: '', severity: undefined }
  api = new HelpApi('/', '')
  appConfig: Config | undefined
  globalStore: GlobalStore
  isLoading: boolean = false

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore
    this.api = new HelpApi(globalStore.endpoint, globalStore.sessionToken, globalStore.onError)

    makeAutoObservable(this)
  }

  createSupportTicket = async (ticket: Ticket) => {
    try {
      this.isLoading = true
      await this.api.createSupportTicket(ticket)
      this.setAlert(this.copy.request_support_submit_success_message, 'success')
    } catch (error) {
      console.error('Error occurred while submitting support ticket:', error)
      this.globalStore.captureException(error, { store: 'HelpStore' })
      this.setAlert(this.copy.request_support_submit_failure_message, 'error')
    } finally {
      this.isLoading = false
    }
  }

  setAlert = (message: string, severity: HelpAlertProps['severity'] = undefined) =>
    (this.alert = { message, severity })

  get copy(): HelpCopy {
    return this.globalStore.copyStore.copy.help
  }

  get helpCategories() {
    const { client_communication_profile, client_profile } = this.globalStore.appDataStore.appData

    const {
      help: { category_list },
    } = this.globalStore.copyStore.copy

    return HelpUtil(
      {
        ...client_communication_profile,
        ...client_profile,
        ...this.globalStore.appConfig.config,
      },
      category_list,
    )
  }
}
